export type PreviewPaneState = "invalid" | "loading" | "error" | "ready";

/**
 * Что показывать в панели превью письма. Белая «бумага» письма появляется
 * только когда есть готовый HTML: до этого скелетон на поверхности темы,
 * при ошибке без HTML сообщение с кнопкой «Повторить». Пока строится превью
 * новой правки, остаётся прежнее письмо (Apollo previousData).
 */
export function previewPaneState(input: {
  valid: boolean;
  loading: boolean;
  failed: boolean;
  hasHtml: boolean;
}): PreviewPaneState {
  if (!input.valid) return "invalid";
  if (input.hasHtml) return "ready";
  if (input.failed && !input.loading) return "error";
  return "loading";
}
